// extracted by mini-css-extract-plugin
export default {"container__img":"photo_container__img__bVdpK","animateImg":"photo_animateImg__NjgQH"};